// 20-05-2025
import { ADD_USER_ID, REMOVE_USER_ID, RESET_USER, USER_SELECTED } from "./actionTypes";

// user
export const userSelected = (userId) => {
  return {
    type: USER_SELECTED,
    payload: userId,
  };
};

export const addUserIds = (id) => {
  return {
    type: ADD_USER_ID,
    payload: id,
  };
};

export const removeUserIds = (id) => {
  return {
    type: REMOVE_USER_ID,
    payload: id,
  };
};

export const resetUser = () => ({
  type: RESET_USER,
});
